module.exports = __webpack_public_path__ + "static/media/splash-guanabara.e06f0b32.png";